import { useContext, useEffect, useState } from 'react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import { GlobalContext } from '../../../../../library/Core/GlobalContext';
import { DispatchEvent, State } from '../../../../../library/Core/SmartTypes';
import smartReducer from '../../../../../library/Core/SmartReducer';
import { handleCompleteLater, handleNext, onCurrentJobSelectionChange } from './EntrepreneurshipOutcomeActions';
import { addUserSpecificDomains } from '../../../../../library/Service/domainService';
import { SmartContext } from '../../../../../library/Core/SmartContext';
import EntrepreneurshipLayout from '../../entrepreneurship/EntrepreneurshipLayout';
import PageBuilder from '../../../../../library/Builders/PageBuilder/PageBuilder';
import { getDomainValueForCode } from '../../../../../library/Core/SmartFunctions';
import OutcomeInformationLayout from '../../OutcomeInformationLayout';

const FOUNDER_STATUS_HIDE_EXPRESSION =
    "!(model.role == 'ADMIN' && row.seniorityLevelCode == 'LEADERSHIP')";

const applyFounderStatusHideExpression = (node: any): any => {
    if (!node) return node;
    if (Array.isArray(node)) return node.map(applyFounderStatusHideExpression);
    if (typeof node !== 'object') return node;
    const next = { ...node };
    if (next.id === 'founderStatus') {
        next.hideExpression = FOUNDER_STATUS_HIDE_EXPRESSION;
    }
    if (next.controlGroup) next.controlGroup = applyFounderStatusHideExpression(next.controlGroup);
    if (next.sectionRepository) next.sectionRepository = applyFounderStatusHideExpression(next.sectionRepository);
    return next;
};

const EntrepreneurshipOutcome = () => {
    const { globalState } = useContext(GlobalContext);
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState('');

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: {
            NEXT: handleNext,
            I_LL_DO_THIS_LATER: handleCompleteLater,
            ROUTER_NAVIGATE: navigate,
            isCurrent: onCurrentJobSelectionChange,
            REDIRECT: setRedirectUrl
        },
    } as any);

    const { formConfig, data, routeInfo } = useLoaderData() as State;

    useEffect(() => {
        const domain = addUserSpecificDomains(new Map([...globalState.domain]), data);
        data['entreprenurshipOutcome'] = data['entreprenurshipOutcome'] || {};
        dispatch({
            type: 'DATA_INIT',
            payload: { formConfig: applyFounderStatusHideExpression(formConfig), data, domain, routeInfo },
        });
    }, []);

    useEffect(() => {
        if (redirectUrl !== '') {
            navigate(redirectUrl);
        }
    }, [redirectUrl]);

    let program_name = getDomainValueForCode(state?.data?.selectedInstitute?.programId,'ALL_PROGRAM_CODE',state);
    let institute_name = getDomainValueForCode(state?.data?.selectedInstitute?.instituteId,'INSTITUTE_DOMAIN',state);
    // let message = `After Completing ${program_name} from ${institute_name}, you mentioned that you became an entrepreneur. Please provide the details of the organization you started after your program completion from the institute`
    let message = `Which company did you join after your ${program_name} from ${institute_name}`;
    
    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            {/* <EntrepreneurshipLayout>{!state.flags.isDataLoading && <PageBuilder data={message}/>}</EntrepreneurshipLayout> */}
            <OutcomeInformationLayout description={message}>{!state.flags.isDataLoading && <PageBuilder />}</OutcomeInformationLayout>  
        </SmartContext.Provider>
    );
};

export default EntrepreneurshipOutcome;
